import { ACTIONS_MACHINE } from '../_constants/machine.constants';

const initialState = {
  byId: {},
};

export function machineReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MACHINE.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MACHINE.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MACHINE.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default machineReducer;
